import { Link, Outlet } from '@tanstack/react-router';
import { FileText, History, Sheet, Tags } from 'lucide-react';

export function SettingsLayout() {
  return (
    <>
      <header className="toolbar">
        <h2 style={{ margin: 0 }}>Settings</h2>
      </header>

      <nav className="subnav">
        <Link to="/settings/lookups" activeProps={{ className: 'active' }}>
          <Tags size={14} /> Brands, Types &amp; Tags
        </Link>
        <Link to="/settings/audit" activeProps={{ className: 'active' }}>
          <History size={14} /> Audit log
        </Link>
        <Link to="/settings/import" activeProps={{ className: 'active' }}>
          <FileText size={14} /> Import CSV
        </Link>
        <Link to="/settings/sheet" activeProps={{ className: 'active' }}>
          <Sheet size={14} /> Google Sheet
        </Link>
      </nav>

      <Outlet />
    </>
  );
}
